<template>
    <div class="form-wrap">
        <div class="form-item">
            <div class="item-title">申请BU：</div>
            <div class="item-text">{{ data.bu_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">调岗类型：</div>
            <div class="item-text">{{ apply.postType[data.req_type] }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">调岗人员：</div>
            <div class="item-text">{{ data.tran_names  }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">申请理由：</div>
            <div class="item-text">{{ data.remark }}</div>
        </div>
        <div class="form-item" v-if="data.status!=1">
            <div class="item-title">审核说明：</div>
            <div class="item-text">{{ data.result }}</div>
        </div>


        <sliderHistoty :data="data.req"></sliderHistoty>

        <!-- 审核 -->
        <div v-if="data.status==1 && $route.name!='my-application'"  v-form:apply-mod>
            <div class="form-line" text="审核处理"></div>

            <div class="form-item">
                <div class="item-title">审核说明：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="'审核说明'" v-tar="examine.result" v-model="examine.result" placeholder="请输入审核说明"></textarea>
                </div>
            </div>

            <div class="form-footer">
                <el-button type="primary" @click="checkPass">通 过</el-button>
                <el-button type="primary" @click="checkNotPass">不通过</el-button>
            </div>
        </div>

        <!-- 重新提交 -->
        <div v-if="data.status == 3 &&  $route.name=='my-application'" v-form:mod-again>
            <div class="form-line" text="申请"></div>

            <div class="form-item">
                <div class="item-title">调岗类型：</div>
                <div class="item-text">
                    <el-select rule="noVal" v-tar="resub.mod_typeId"  v-model="resub.mod_typeId" placeholder="请选择">
                        <el-option v-for="item in types" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title">调岗人员：</div>
                <div class="item-text">
                    <el-select rule="noVal" v-tar="resub.mod_changeIds" v-model="resub.mod_changeIds" multiple filterable allow-create placeholder="请选择调岗人员" style="width: 452px;">
                        <el-option v-for="item in buMembers" :key="item.id" :label="item.real_name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title">申请理由：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="['申请理由']" v-tar="resub.mod_reason"  v-model="resub.mod_reason" placeholder="请输入申请理由"></textarea>
                </div>
            </div>
            <div class="form-footer">
                <el-button type="primary" @click="subAgain">重新提交</el-button>
            </div>

        </div>

    </div>
</template>

<script>
    import sliderHistoty from "src/components/slider/slider_history.vue"
    import { mapGetters,mapState } from "vuex"

    export default {
        props:["sliderArg","data","resub","examine"],
        components:{
            sliderHistoty,
        },
        data(){
            return {
                types:[{
                    id:1,
                    label:"内部转岗"
                }],
                buMembers:[],
            }
        },

        computed:{
            ...mapState(["apply","allAddPost"]),
        },

        watch:{
            data(val){
                let count = 0;
                for(let i in val){
                    count++;
                };
                if(count == 0){
                    this.$form.clear("mod-again");
                    this.$form.clear("apply-mod");
                }
            },
        },

        created(){
            // 调岗人员列表
            let url = `api/manager/bu_user`;
            this.$http.get(url).then(res=>{
                if(res.status == 200){
                    this.buMembers = res.res_data.filter(user=>{
                        return user.bu_identity_type != 1 && user.isTransferred == 0;
                    });
                }
            });
        },

        methods:{
            checkPass(){
                let res = this.$form.check("apply-mod");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 0;
				this.sliderArg.insideFlag = true;
                // this.$emit('pass');
            },
            checkNotPass(){
                let res = this.$form.check("apply-mod");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 1;
				this.sliderArg.insideFlag = true;
                // this.$emit('notpass');
            },
            subAgain(){  //重提交
                let res = this.$form.check("mod-again");
                if(!res){
                    return;
                }

                let url = `api/manager/transfer_position_req/${this.data.id}`;
                this.$http.put(url,{
                    req_type:this.resub.mod_typeId,
                    sub_user_ids:this.resub.mod_changeIds.join(","),
                    remark:this.resub.mod_reason,
                }).then(res=>{
                    if(res.status == 200){
                        this.successTip("重新提交成功");
                        this.$emit("refresh");
                    }
                }).catch(error=>{
                    this.errorTip("提交失败");
                });

            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/slider.less";
</style>





// WEBPACK FOOTER //
// sliderMod.vue?e66d0e8c